import React, {Component} from 'react';
import {Button, message, Modal, Icon} from 'antd';
import {Redirect} from 'react-router';
import './style.less';

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      invoiceTypeData: ['不开发票', '增值税普票-纸制', '增值税普票-电子', '增值税专票'],
      firstStatusData: ['审核中', '审核通过', '审核不通过'],
      secondStatusData: ['审核中', '审核通过', '审核不通过'],
      status: ['审核中', '审核不通过', '充值中', '充值失败', '充值成功'],
      form: {
        gmt_created: '',
        agent_no: '',
        agent_name: '',
        recharge_no: '',
        recharge_amt: '',
        recharge_type: '',
        invoice_type: '',
        first_check_status: '',
        first_check_name: '',
        gmt_first_check: '',
        second_check_name: '',
        first_check_rmk: '',
        invoice_name: '',
        invoice_tax_no: '',
        bank_name: '',
        email_address: '',
        recipient_phone: '',
        recipient_address: ''
      },
      files: [],
      isShowImg: false, // 显示图片原图
      picUrl: '', // 图片链接地址
    };
  }
  componentWillMount() {
    this.initForm();
  }
  initForm = () => {
    const id = this.props.location.state.id;
    if (!this.props.location.state.id) return false;
    window.api('eps.recharge.getinfo', {recharge_id: id}).then(rs => {
      const form = Object.assign(rs.recharge, rs.recharge_invoice);
      this.setState({form, files: rs.files});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }
  goBackEvent = () => {
    window.history.go(-1);
  }
  showImg = (value, url) => {
    this.setState({isShowImg: value, picUrl: url});
  }
  render() {
    const {
      redirect,
      form,
      invoiceTypeData,
      firstStatusData,
      secondStatusData,
      status,
      files,
      picUrl,
      isShowImg
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div className="topup-blocks topup-detail-page">
        <Modal
          title={false}
          footer={false}
          onCancel={this.showImg.bind(this, false, '')}
          visible={isShowImg}
          width={580}
          wrapClassName="detail-img-modal"
        >
          <img src={picUrl} alt="" style={{width: '100%', display: 'block'}} />
        </Modal>
        <div className="detail-header">
          {/* <Button type="primary" onClick={this.goBackEvent.bind(this)}>
            <Icon type="left" /> 返回
          </Button> */}
          <div className="detail-header-text">
            <h1 className="detail-page-title">充值详情</h1>
            <p className="detail-page-desc">查看充值单信息与审核记录</p>
          </div>
        </div>
        <div className="detail-card">
          <h2 className="detail-section-title">充值详情</h2>
          <dl className="detail-items detail-section-body">
            <dd>
              <div className="detail-row"><span className="detail-label">创建日期</span><span className="detail-value">{form.gmt_created}</span></div>
              <div className="detail-row"><span className="detail-label">代理商ID/名称</span><span className="detail-value">{form.agent_no} / {form.agent_name}</span></div>
              <div className="detail-row"><span className="detail-label">充值单号</span><span className="detail-value">{form.recharge_no}</span></div>
              <div className="detail-row"><span className="detail-label">充值金额</span><span className="detail-value">{form.recharge_amt}</span></div>
              <div className="detail-row"><span className="detail-label">充值方式</span><span className="detail-value">{Number(form.recharge_type) === 1 ? '返佣账号充值' : '线下转账'}</span></div>
              {Number(form.recharge_type) === 2 ? <div className="detail-row"><span className="detail-label">是否开票</span><span className="detail-value">{Number(form.invoice_type) !== 0 ? '是' : '否'}</span></div> : null}
              {Number(form.recharge_type) === 2 ? <div className="detail-row"><span className="detail-label">发票类型</span><span className="detail-value">{invoiceTypeData[Number(form.invoice_type)]}</span></div> : null}
              {Number(form.recharge_type) === 2 && files && files.length > 0 ? (
                <div className="detail-row detail-row-full">
                  <span className="detail-label">打款截图</span>
                  <div className="detail-screenshots">
                    {files.map((item, index) => (
                      <div className="imgBox" key={index}>
                        <div onClick={this.showImg.bind(this, true, item)}>查看</div>
                        <img src={item} alt="" className="files" />
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              {Number(form.invoice_type) !== 0 ? <div className="detail-row"><span className="detail-label">名称</span><span className="detail-value">{form.invoice_name}</span></div> : null}
              {Number(form.invoice_type) === 2 ? <div className="detail-row"><span className="detail-label">邮箱</span><span className="detail-value">{form.email_address}</span></div> : null}
              {Number(form.invoice_type) !== 0 ? <div className="detail-row detail-row-full"><span className="detail-label">税号</span><span className="detail-value">{form.invoice_tax_no}</span></div> : null}
              {Number(form.invoice_type) === 1 && form.recipient_address ? <div className="detail-row detail-row-full"><span className="detail-label">发票寄回地址</span><span className="detail-value">{form.recipient_address.split('=').slice(0, 3).join(' ')}</span></div> : null}
              {Number(form.invoice_type) === 1 && form.recipient_address ? <div className="detail-row detail-row-full"><span className="detail-label">详细地址</span><span className="detail-value">{form.recipient_address.split('=')[3]}</span></div> : null}
              {Number(form.invoice_type) === 1 ? <div className="detail-row"><span className="detail-label">收件人</span><span className="detail-value">{form.recipient_name}</span></div> : null}
              {Number(form.invoice_type) === 1 ? <div className="detail-row"><span className="detail-label">手机号</span><span className="detail-value">{form.recipient_phone}</span></div> : null}
              {Number(form.invoice_type) === 3 && form.bank_account_no ? <div className="detail-row detail-row-full"><span className="detail-label">银行账户</span><span className="detail-value">{form.bank_account_no}</span></div> : null}
              {Number(form.invoice_type) === 3 && form.bank_name ? <div className="detail-row detail-row-full"><span className="detail-label">开户支行</span><span className="detail-value">{form.bank_name}</span></div> : null}
              {Number(form.invoice_type) === 3 && form.company_address ? <div className="detail-row detail-row-full"><span className="detail-label">单位所在地区</span><span className="detail-value">{form.company_address.split('=').slice(0, 3).join(' ')}</span></div> : null}
              {Number(form.invoice_type) === 3 && form.company_address ? <div className="detail-row detail-row-full"><span className="detail-label">单位详细地址</span><span className="detail-value">{form.company_address.split('=')[3]}</span></div> : null}
              {Number(form.invoice_type) === 3 ? <div className="detail-row detail-row-full"><span className="detail-label">电话号码</span><span className="detail-value">{form.company_phone}</span></div> : null}
              {Number(form.invoice_type) === 3 && form.recipient_address ? <div className="detail-row detail-row-full"><span className="detail-label">发票寄回地址</span><span className="detail-value">{form.recipient_address.split('=').join(' ')}</span></div> : null}
              {Number(form.invoice_type) === 3 ? <div className="detail-row"><span className="detail-label">收件人</span><span className="detail-value">{form.recipient_name}</span></div> : null}
              {Number(form.invoice_type) === 3 ? <div className="detail-row"><span className="detail-label">手机号</span><span className="detail-value">{form.recipient_phone}</span></div> : null}
            </dd>
          </dl>
        </div>
        <div className="detail-card">
          <h2 className="detail-section-title">审核信息</h2>
          <dl className="detail-items detail-section-body">
            <dd>
              <div className="detail-row"><span className="detail-label">初审状态</span><span className="detail-value">{form.first_check_status != null ? firstStatusData[Number(form.first_check_status) - 1] : '--'}</span></div>
              <div className="detail-row"><span className="detail-label">审核时间</span><span className="detail-value">{form.gmt_first_check || '--'}</span></div>
              <div className="detail-row detail-row-full"><span className="detail-label">审核人</span><span className="detail-value">{form.first_check_name || '--'}</span></div>
              <div className="detail-row detail-row-full"><span className="detail-label">审核意见</span><span className="detail-value">{form.first_check_rmk || '--'}</span></div>
            </dd>
            {Number(form.first_check_status) === 2 && (
              <dd className="detail-sub-section">
                <div className="detail-row"><span className="detail-label">复审状态</span><span className="detail-value">{form.second_check_status != null ? secondStatusData[Number(form.second_check_status) - 1] : '--'}</span></div>
                <div className="detail-row"><span className="detail-label">审核时间</span><span className="detail-value">{form.gmt_second_check || '--'}</span></div>
                <div className="detail-row detail-row-full"><span className="detail-label">审核人</span><span className="detail-value">{form.second_check_name || '--'}</span></div>
                <div className="detail-row detail-row-full"><span className="detail-label">审核意见</span><span className="detail-value">{form.second_check_rmk || '--'}</span></div>
              </dd>
            )}
            {Number(form.first_check_status) === 3 && (
              <dd className="detail-sub-section">
                <div className="detail-row"><span className="detail-label">复审状态</span><span className="detail-value">{form.first_check_status != null ? firstStatusData[Number(form.first_check_status) - 1] : '--'}</span></div>
                <div className="detail-row"><span className="detail-label">审核时间</span><span className="detail-value">{form.gmt_first_check || '--'}</span></div>
                <div className="detail-row detail-row-full"><span className="detail-label">审核人</span><span className="detail-value">{form.first_check_name || '--'}</span></div>
                <div className="detail-row detail-row-full"><span className="detail-label">审核意见</span><span className="detail-value">{form.first_check_rmk || '--'}</span></div>
              </dd>
            )}
          </dl>
        </div>
        {this.props.location.state && this.props.location.state.type !== 0 && (
          <div className="detail-card">
            <h2 className="detail-section-title">充值信息</h2>
            <dl className="detail-items detail-section-body">
              <dd>
                <div className="detail-row"><span className="detail-label">充值时间</span><span className="detail-value">{form.gmt_created}</span></div>
                <div className="detail-row"><span className="detail-label">充值状态</span><span className="detail-value">{status[Number(form.status) - 1]}</span></div>
              </dd>
            </dl>
          </div>
        )}
        <div className="detail-actions">
          <Button type="primary" className="btn-back" onClick={this.goBackEvent.bind(this)}>返回</Button>
        </div>
      </div>
    );
  }
}
export default Detail;



// WEBPACK FOOTER //
// ./src/containers/backEnd/topupMangement/detail.jsx